import React, { Component } from 'react';
import { Route } from 'react-router';
import Layout from './components/layout/Layout';
import Home from './components/home/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';

import './styles/theme.css'

const App = () => {
return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/counter' component={Counter} />
        <Route path='/fetch-data' component={FetchData} />
      </Layout>
    );
  }
export default App;
